import React from 'react';
import DocumentsGrid from '../components/documents/DocumentsGrid';

const DocumentsPage = () => {
  return <DocumentsGrid />;
};

export default DocumentsPage;